import styled, {css} from 'styled-components'

type StyledContainerProps = {
    $fullWidth: boolean
    $fullHeight: boolean
}

export const StyledContainer = styled.div<StyledContainerProps>`
    ${({$fullWidth, $fullHeight, theme: {spacing, containerWidth}}) => css`
        width: 100%;
        height: ${$fullHeight ? '100%' : 'auto'};
        padding: ${spacing * 4}px;
        max-width: ${$fullWidth ? '100%' : `${containerWidth}px`};
        margin: 0 auto;
        overflow: auto;
    `}
`
